// extracted by mini-css-extract-plugin
module.exports = {"itemListWrapper":"ItemListWrapper_itemListWrapper__3iy9X","touchscreenItemListWrapper":"ItemListWrapper_touchscreenItemListWrapper__1OGOT"};